/**
 * Módulo caja POSKN: estado, detalles, apertura/cierre e impresión de reportes.
 */

function getAjaxUrl(win) {
	const cfg = win.POSKN_API_CONFIG || {};
	return cfg.ajaxUrl || win.ajaxurl || 'pos-ajax.php';
}

function getNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function getUserDisplayName(win) {
	const ej = win.posknEjecutorFacturacion || {};
	return ej.nombre || 'Cajero';
}

function notify(win, text, type) {
	if (typeof win.mostrarNotificacion === 'function') win.mostrarNotificacion(text, type);
	else if (type === 'error') win.alert(text);
}

function initCajaEvents(win, $) {
	if (win._posknCajaBound) return;
	win._posknCajaBound = true;

	$(document).on('click', '#abrir-caja-btn', () => win.abrirModalCaja());
	$(document).on('click', '#btn-confirmar-apertura', () => win.confirmarAperturaCaja());
	$(document).on('click', '#imprimir-reporte-btn', () => win.imprimirReporteCaja());
	$(document).on('click', '#imprimir-cierre-btn', () => win.imprimirCierre());
	$(document).on('click', '#nueva-caja-btn', () => win.abrirNuevaCaja());
	$(document).on('click', '#cerrar-caja-btn', () => win.cerrarCajaPrompt());
}

function updateCajaTerminalLabel($, data) {
	const el = $('#caja-terminal-nombre');
	if (!el.length) return;
	const nombre = data && data.register_nombre ? String(data.register_nombre) : '';
	if (nombre) {
		el.text(`🖥️ Terminal: ${nombre}`).show();
	} else {
		el.hide().text('');
	}
}

export function attachCajaGlobals(win, $) {
	initCajaEvents(win, $);

	win.mostrarMensaje = function mostrarMensaje(texto, tipo) {
		notify(win, texto, tipo);
	};

	win.mostrarEstadoPorDefecto = function mostrarEstadoPorDefecto() {
		win._posknCajaCache = { estado: 'cerrada', ts: Date.now(), data: null };
		$('#estado-caja-texto').text('CERRADA').removeClass('estado-abierta estado-desconocido').addClass('estado-cerrada');
		updateCajaTerminalLabel($, null);
		$('#abrir-caja-btn').show();
		$('#cerrar-caja-btn').hide();
		$('#monto-inicial').text('$0.00');
		if ($('#monto-inicial-bs').length) $('#monto-inicial-bs').text('Bs. 0.00');
		$('#ventas-dia').text('$0.00');
		if ($('#ventas-dia-bs').length) $('#ventas-dia-bs').text('Bs. 0.00');
		$('#total-caja').text('$0.00');
		if ($('#total-caja-bs').length) $('#total-caja-bs').text('Bs. 0.00');
	};

	win.mostrarEstadoCajaDesconocido = function mostrarEstadoCajaDesconocido() {
		const prev = win._posknCajaCache && win._posknCajaCache.estado;
		win._posknCajaCache = {
			estado: 'desconocido',
			ts: Date.now(),
			data: (win._posknCajaCache && win._posknCajaCache.data) || null,
			prevEstado: prev || null,
		};
		$('#estado-caja-texto')
			.text('SIN CONEXIÓN')
			.removeClass('estado-abierta estado-cerrada')
			.addClass('estado-desconocido');
		// No forzar CERRADA ni mostrar Abrir: evita caja huérfana / doble apertura
		$('#abrir-caja-btn').prop('disabled', true).show();
		$('#cerrar-caja-btn').prop('disabled', true).show();
	};

	win.actualizarInterfaz = function actualizarInterfaz(response) {
		if (!response.success) {
			notify(win, `Error: ${response.data}`, 'error');
			return;
		}
		const data = response.data;
		const tasa = typeof win.TASA_DOLAR !== 'undefined' ? win.TASA_DOLAR : 100;
		win._posknCajaCache = { estado: data.estado, ts: Date.now(), data };

		if (data.estado === 'abierta') {
			$('#estado-caja-texto').text('ABIERTA').removeClass('estado-cerrada estado-desconocido').addClass('estado-abierta');
			updateCajaTerminalLabel($, data);
			$('#abrir-caja-btn').prop('disabled', false).hide();
			$('#cerrar-caja-btn').prop('disabled', false).show();
			$('#monto-inicial').text(`$${parseFloat(data.monto_inicial || 0).toFixed(2)}`);
			if ($('#monto-inicial-bs').length) {
				$('#monto-inicial-bs').text(`Bs. ${parseFloat(data.monto_inicial_bs || 0).toFixed(2)}`).show();
			}
			const ventasUsd = parseFloat(data.ventas_dia_usd ?? data.ventas_dia ?? 0);
			const ventasBs = parseFloat(data.ventas_dia_bs ?? 0);
			$('#ventas-dia').text(`$${ventasUsd.toFixed(2)}`);
			if ($('#ventas-dia-bs').length) $('#ventas-dia-bs').text(`Bs. ${ventasBs.toFixed(2)}`).show();
			const ingresosCajaUsd = parseFloat(data.ingresos_caja_usd || data.ingresos_caja || 0);
			const ingresosCajaBs = parseFloat(data.ingresos_caja_bs || 0);
			if ($('#ingresos-caja').length) $('#ingresos-caja').text(`$${ingresosCajaUsd.toFixed(2)}`);
			if ($('#ingresos-caja-bs').length) $('#ingresos-caja-bs').text(`Bs. ${ingresosCajaBs.toFixed(2)}`).show();
			const gastosDiaUsd = parseFloat(data.gastos_dia_usd || data.gastos_dia || 0);
			const gastosDiaBs = parseFloat(data.gastos_dia_bs || 0);
			if ($('#gastos-dia').length) $('#gastos-dia').text(`$${gastosDiaUsd.toFixed(2)}`);
			if ($('#gastos-dia-bs').length) $('#gastos-dia-bs').text(`Bs. ${gastosDiaBs.toFixed(2)}`).show();
			const reembolsosDia = parseFloat(data.reembolsos_dia || 0);
			if ($('#reembolsos-dia').length) $('#reembolsos-dia').text(`$${reembolsosDia.toFixed(2)}`);
			if ($('#reembolsos-dia-bs').length) {
				$('#reembolsos-dia-bs').text(`Bs. ${(reembolsosDia * tasa).toFixed(2)}`).show();
			}
			$('#total-caja').text(`$${parseFloat(data.total_caja || 0).toFixed(2)}`);
			const totalCajaBs = parseFloat(data.total_caja_bs || data.total_caja * tasa);
			if ($('#total-caja-bs').length) $('#total-caja-bs').text(`Bs. ${totalCajaBs.toFixed(2)}`).show();
			win.mostrarInfoCaja(data);
			if (typeof win.cargarGastosCaja === 'function') win.cargarGastosCaja();
		} else {
			win._posknCajaCache = { estado: 'cerrada', ts: Date.now(), data };
			$('#estado-caja-texto').text('CERRADA').removeClass('estado-abierta estado-desconocido').addClass('estado-cerrada');
			updateCajaTerminalLabel($, null);
			$('#abrir-caja-btn').prop('disabled', false).show();
			$('#cerrar-caja-btn').prop('disabled', false).hide();
			$('#imprimir-reporte-btn').hide();
			$('#monto-inicial').text('$0.00');
			if ($('#monto-inicial-bs').length) $('#monto-inicial-bs').text('Bs. 0.00');
			$('#ventas-dia').text('$0.00');
			if ($('#ventas-dia-bs').length) $('#ventas-dia-bs').text('Bs. 0.00');
			if ($('#ingresos-caja').length) $('#ingresos-caja').text('$0.00');
			if ($('#ingresos-caja-bs').length) $('#ingresos-caja-bs').text('Bs. 0.00');
			if ($('#gastos-dia').length) $('#gastos-dia').text(`$${parseFloat(data.gastos_dia || 0).toFixed(2)}`);
			if ($('#gastos-dia-bs').length) $('#gastos-dia-bs').text('Bs. 0.00');
			if ($('#reembolsos-dia').length) $('#reembolsos-dia').text('$0.00');
			if ($('#reembolsos-dia-bs').length) $('#reembolsos-dia-bs').text('Bs. 0.00');
			$('#total-caja').text('$0.00');
			if ($('#total-caja-bs').length) $('#total-caja-bs').text('Bs. 0.00');
			if ($('#lista-movimientos').length) {
				$('#lista-movimientos').html('<p class="no-movimientos">No hay movimientos registrados</p>');
			}
			win.datosReporte = null;
			if (typeof win.cargarGastosCaja === 'function') win.cargarGastosCaja();
		}
	};

	win.cargarEstadoCaja = function cargarEstadoCaja() {
		const btnAbrir = $('#abrir-caja-btn');
		const btnCerrar = $('#cerrar-caja-btn');
		if (btnAbrir.length === 0 || btnCerrar.length === 0) {
			setTimeout(win.cargarEstadoCaja, 500);
			return;
		}
		win.POSKN.api.getCajaStatus(15000)
			.then((response) => win.actualizarInterfaz(response))
			.catch(() => {
				notify(
					win,
					'No se pudo verificar el estado de caja (conexión). No abras otra hasta recuperar red.',
					'warning',
				);
				if (typeof win.mostrarEstadoCajaDesconocido === 'function') {
					win.mostrarEstadoCajaDesconocido();
				}
			});
	};

	win.reconciliarEstadoCaja = function reconciliarEstadoCaja() {
		return win.POSKN.api
			.getCajaStatus(15000)
			.then((response) => {
				win.actualizarInterfaz(response);
				return response;
			})
			.catch(() => {
				if (typeof win.mostrarEstadoCajaDesconocido === 'function') {
					win.mostrarEstadoCajaDesconocido();
				}
				return null;
			});
	};

	win.mostrarInfoCaja = function mostrarInfoCaja(data) {
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: { action: 'pos_obtener_detalles_caja', caja_id: data.caja_id, nonce: getNonce(win) },
			success(response) {
				if (response.success) win.mostrarDetallesCaja(data, response.data);
				else win.mostrarInfoBasica(data);
			},
			error() {
				win.mostrarInfoBasica(data);
			},
		});
	};

	win.mostrarInfoBasica = function mostrarInfoBasica(data) {
		const infoHtml = `
			<div class="caja-info-detalle">
				<p><strong>Caja ID:</strong> ${data.caja_id}</p>
				${data.register_nombre ? `<p><strong>Terminal:</strong> ${data.register_nombre}</p>` : ''}
				<p><strong>Abierta:</strong> ${new Date(data.fecha_apertura).toLocaleString()}</p>
				<p><strong>Pedidos procesados:</strong> ${data.pedidos_count}</p>
			</div>`;
		$('#lista-movimientos').html(infoHtml);
		$('#imprimir-reporte-btn').show();
		win.datosReporte = {
			basica: data,
			detalles: { metodos_pago: {}, productos_vendidos: [], gastos: [], reembolsos: [], reembolsos_total: 0 },
		};
	};

	win.mostrarDetallesCaja = function mostrarDetallesCaja(dataBasica, detalles) {
		win.posMetodosPagoNombres = detalles.metodos_pago_nombres || {};
		win.posMetodosPagoMoneda = detalles.metodos_pago_moneda || {};
		const fmt = win.formatearNombreMetodo;
		const sym = win.obtenerSimboloMoneda;
		const icon = win.obtenerIconoMetodo;

		let infoHtml = `
			<div class="caja-info-detalle">
				<div class="info-basica">
					<h4>📊 Información General</h4>
					<p><strong>Caja ID:</strong> ${dataBasica.caja_id}</p>
					${dataBasica.register_nombre ? `<p><strong>Terminal:</strong> ${dataBasica.register_nombre}</p>` : ''}
					<p><strong>Abierta:</strong> ${new Date(dataBasica.fecha_apertura).toLocaleString()}</p>
					<p><strong>Pedidos procesados:</strong> ${dataBasica.pedidos_count}</p>
				</div>`;

		if (parseFloat(detalles.descuentos_total || 0) > 0 || (detalles.descuentos_pedidos && detalles.descuentos_pedidos.length)) {
			const lista = detalles.descuentos_pedidos || [];
			infoHtml += `
				<div class="descuentos-detalle" style="margin-top:12px;padding:8px;background:#fff8e1;border-radius:6px;border-left:4px solid #ff9800;">
					<h4 style="margin:0 0 6px 0;">🏷️ Descuentos aplicados</h4>
					<p style="margin:0 0 6px 0;"><strong>Total descontado:</strong> -$${parseFloat(detalles.descuentos_total || 0).toFixed(2)}</p>`;
			if (lista.length > 0) {
				infoHtml += '<ul style="margin:0;padding-left:16px;font-size:12px;">';
				lista.forEach((d) => {
					const num = String(d.numero || d.order_id || '');
					const m = parseFloat(d.monto || 0);
					const mStr = Math.abs(m - Math.round(m)) < 0.001 ? String(Math.round(m)) : m.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
					infoHtml += `<li><strong>${num}</strong> -${mStr}$</li>`;
				});
				infoHtml += '</ul>';
			}
			infoHtml += '</div>';
		}

		if (parseFloat(detalles.creditos_total || 0) > 0 || (detalles.creditos_pedidos && detalles.creditos_pedidos.length)) {
			const listaCred = detalles.creditos_pedidos || [];
			infoHtml += `
				<div class="creditos-detalle" style="margin-top:12px;padding:8px;background:#ffebee;border-radius:6px;border-left:4px solid #c62828;">
					<h4 style="margin:0 0 6px 0;">💳 Créditos</h4>
					<p style="margin:0 0 6px 0;"><strong>Total a crédito:</strong> $${parseFloat(detalles.creditos_total || 0).toFixed(2)}</p>`;
			if (listaCred.length > 0) {
				infoHtml += '<ul style="margin:0;padding-left:16px;font-size:12px;">';
				listaCred.forEach((c) => {
					const num = String(c.numero || c.order_id || '');
					const cli = String(c.cliente || '').trim();
					const m = parseFloat(c.monto || 0);
					infoHtml += `<li><strong>#${num}</strong>${cli ? ` · ${cli}` : ''} — $${m.toFixed(2)}</li>`;
				});
				infoHtml += '</ul>';
			}
			infoHtml += '</div>';
		}

		const abonosUsd = parseFloat(detalles.abonos_credito_total_usd || 0);
		const abonosBs = parseFloat(detalles.abonos_credito_total_bs || 0);
		const abonosItems = detalles.abonos_credito || [];
		if (abonosUsd > 0 || abonosBs > 0 || abonosItems.length) {
			infoHtml += `
				<div class="abonos-credito-detalle" style="margin-top:12px;padding:8px;background:#e8f5e9;border-radius:6px;border-left:4px solid #2e7d32;">
					<h4 style="margin:0 0 6px 0;">💵 Abonos de crédito cobrados</h4>
					<p style="margin:0 0 6px 0;"><strong>Total cobrado:</strong> $${abonosUsd.toFixed(2)}`;
			if (abonosBs > 0) {
				infoHtml += ` · Bs. ${abonosBs.toFixed(2)}`;
			}
			infoHtml += `</p>
					<p style="margin:0 0 6px 0;font-size:12px;color:#555;">Estos montos ya están sumados al método de pago correspondiente en la caja.</p>`;
			if (abonosItems.length > 0) {
				infoHtml += '<ul style="margin:0;padding-left:16px;font-size:12px;">';
				abonosItems.slice(0, 12).forEach((a) => {
					const mon = String(a.moneda || 'USD').toUpperCase() === 'BS' ? 'Bs' : 'USD';
					const sym = mon === 'BS' ? 'Bs. ' : '$';
					const met = a.metodo_pago ? ` · ${fmt(a.metodo_pago)}` : '';
					infoHtml += `<li>${a.descripcion || 'Abono'}${met} — ${sym}${parseFloat(a.monto || 0).toFixed(2)}</li>`;
				});
				if (abonosItems.length > 12) {
					infoHtml += `<li><em>+ ${abonosItems.length - 12} abonos más</em></li>`;
				}
				infoHtml += '</ul>';
			}
			infoHtml += '</div>';
		}

		if (detalles.metodos_pago && Object.keys(detalles.metodos_pago).length > 0) {
			infoHtml += `<div class="metodos-pago-detalle"><h4>💳 Métodos de Pago</h4><div class="metodos-grid">`;
			const metodosConMonto = Object.entries(detalles.metodos_pago).filter(([, monto]) => parseFloat(monto) > 0);
			if (metodosConMonto.length > 0) {
				metodosConMonto.forEach(([metodo, monto]) => {
					const montoNum = parseFloat(monto);
					infoHtml += `
						<div class="metodo-item">
							<span class="metodo-icono">${icon(metodo)}</span>
							<span class="metodo-nombre">${fmt(metodo)}</span>
							<span class="metodo-monto">${sym(metodo)}${montoNum.toFixed(2)}</span>
						</div>`;
				});
			} else {
				infoHtml += `<div class="metodo-item"><span>No hay métodos de pago registrados</span></div>`;
			}
			infoHtml += `</div></div>`;
		}

		if (detalles.productos_vendidos?.length) {
			infoHtml += `<div class="productos-vendidos-detalle"><h4>📦 Productos Más Vendidos</h4><div class="productos-lista">`;
			detalles.productos_vendidos.slice(0, 5).forEach((producto) => {
				infoHtml += `
					<div class="producto-item">
						<span class="producto-nombre">${producto.name}</span>
						<span class="producto-cantidad">${producto.quantity} unid.</span>
						<span class="producto-total">$${parseFloat(producto.total).toFixed(2)}</span>
					</div>`;
			});
			if (detalles.productos_vendidos.length > 5) {
				infoHtml += `<div class="productos-mas"><small>+ ${detalles.productos_vendidos.length - 5} productos más</small></div>`;
			}
			infoHtml += `</div></div>`;
		}

		infoHtml += `</div>`;
		$('#lista-movimientos').html(infoHtml);
		$('#imprimir-reporte-btn').show();
		win.datosReporte = { basica: dataBasica, detalles };
		if (detalles.reembolsos_total !== undefined) {
			win.datosReporte.basica.reembolsos_dia = detalles.reembolsos_total;
		}
	};

	win.abrirCajaDirecta = function abrirCajaDirecta() {
		if (typeof win.posknRequireRegisterSelected === 'function' && !win.posknRequireRegisterSelected()) {
			return;
		}
		$('#apertura-monto-usd').val('0');
		$('#apertura-monto-bs').val('0');
		$('#modal-apertura-caja').css('display', 'flex');
	};

	win.abrirModalCaja = function abrirModalCaja() {
		win.abrirCajaDirecta();
	};

	win.confirmarAperturaCaja = function confirmarAperturaCaja() {
		if (typeof win.posknRequireRegisterSelected === 'function' && !win.posknRequireRegisterSelected()) {
			return;
		}
		// Si hay un solo terminal, forzar selección antes de abrir
		const regs = win._posknRegistersList || [];
		if (regs.length === 1 && regs[0] && regs[0].id && typeof win.seleccionarRegister === 'function') {
			const cur =
				(win.posknRegisterSeleccionado && win.posknRegisterSeleccionado.id) ||
				0;
			if (parseInt(cur, 10) !== parseInt(regs[0].id, 10)) {
				win.seleccionarRegister(regs[0].id, true);
			}
		}
		const montoUsd = parseFloat($('#apertura-monto-usd').val()) || 0;
		const montoBs = parseFloat($('#apertura-monto-bs').val()) || 0;
		if (montoUsd < 0 || montoBs < 0) {
			notify(win, 'Los montos no pueden ser negativos', 'warning');
			return;
		}
		$('#btn-confirmar-apertura').prop('disabled', true).text('Enviando...');
		win.POSKN.api.openCaja(montoUsd, montoBs, 20000)
			.then((response) => {
				$('#btn-confirmar-apertura').prop('disabled', false).text('Abrir Caja');
				if (response && response.success) {
					if (typeof win.cerrarModal === 'function') win.cerrarModal('modal-apertura-caja');
					else $('#modal-apertura-caja').hide();
					const data = response.data || {};
					// Actualizar UI de inmediato (no depender de un segundo request que falle)
					if (typeof win.actualizarInterfaz === 'function') {
						win.actualizarInterfaz({
							success: true,
							data: Object.assign(
								{
									estado: 'abierta',
									monto_inicial: montoUsd,
									monto_inicial_bs: montoBs,
									ventas_dia: 0,
									ventas_dia_usd: 0,
									ventas_dia_bs: 0,
									ingresos_caja: 0,
									ingresos_caja_usd: 0,
									ingresos_caja_bs: 0,
									gastos_dia: 0,
									gastos_dia_usd: 0,
									gastos_dia_bs: 0,
									reembolsos_dia: 0,
									pedidos_count: 0,
									total_caja: montoUsd,
									total_caja_bs: montoBs,
									fecha_apertura: new Date().toISOString(),
								},
								data,
								{ estado: 'abierta' },
							),
						});
					}
					notify(
						win,
						`🎉 ¡CAJA ABIERTA! $${montoUsd.toFixed(2)} / Bs. ${montoBs.toFixed(2)}`,
						'success',
					);
					// Mostrar módulo sin recargar estado todavía (evita pisar ABIERTA con CERRADA)
					$('.pos-container').hide();
					$('.modulo-contenido').hide();
					$('#modulo-caja').show();
					$('.menu-btn').removeClass('active');
					$('.menu-btn[data-section="caja"]').addClass('active');
					setTimeout(() => {
						if (typeof win.reconciliarEstadoCaja === 'function') win.reconciliarEstadoCaja();
						else if (typeof win.cargarEstadoCaja === 'function') win.cargarEstadoCaja();
					}, 1000);
				} else {
					const err =
						(response && (response.data || response.message)) || 'Error al abrir caja';
					notify(win, `❌ ${typeof err === 'string' ? err : 'Error al abrir caja'}`, 'error');
				}
			})
			.catch((xhr) => {
				$('#btn-confirmar-apertura').prop('disabled', false).text('Abrir Caja');
				let msg = 'Error de conexión al abrir caja';
				if (xhr?.responseJSON?.data) msg = xhr.responseJSON.data;
				else if (xhr?.responseText) {
					try {
						const json = JSON.parse(xhr.responseText);
						if (json.data) msg = json.data;
					} catch (_e) {
						/* no JSON */
					}
				} else if (xhr?.data) msg = xhr.data;
				notify(win, `❌ ${msg}`, 'error');
			});
	};

	win.cerrarCajaPrompt = function cerrarCajaPrompt() {
		const pendientes =
			typeof win.posknHayPedidosPendientesLocales === 'function'
				? win.posknHayPedidosPendientesLocales()
				: { ok: false, count: 0 };
		if (pendientes.ok && pendientes.count > 0) {
			notify(
				win,
				`No se puede cerrar caja: hay ${pendientes.count} pedido(s) en cola o enviándose. Espera a que suban o anula el envío para no perder la venta.`,
				'error',
			);
			if (typeof win.procesarColaSubida === 'function') win.procesarColaSubida();
			if (pendientes.reason === 'cola' && typeof win.verListaPendientesSubir === 'function') {
				win.verListaPendientesSubir();
			}
			return;
		}
		const montoCierre = win.prompt('Ingresa el monto de cierre real en caja (USD):');
		if (montoCierre === null || isNaN(montoCierre) || parseFloat(montoCierre) < 0) {
			if (montoCierre !== null) notify(win, 'Por favor ingresa un monto válido', 'error');
			return;
		}
		if (!win.confirm('¿Estás seguro que deseas cerrar la caja?')) return;
		const cajaIdPrompt =
			(win._posknCajaCache && win._posknCajaCache.data && win._posknCajaCache.data.caja_id) ||
			(win._posknCierreState && win._posknCierreState.cajaId) ||
			0;
		win.POSKN.api.closeCaja(parseFloat(montoCierre), {}, 60000, cajaIdPrompt)
			.then((response) => {
				if (response.success && response.data && String(response.data.estado || '') === 'cerrada') {
					notify(win, `💰 ${response.data.message}`, 'success');
					win.mostrarResumenCierre(response.data);
					if (typeof win.reconciliarEstadoCaja === 'function') win.reconciliarEstadoCaja();
					else win.cargarEstadoCaja();
					if (typeof win.mostrarModalCierreCompletado === 'function') {
						win.mostrarModalCierreCompletado(response.data, { autoPrint: true, cerrado: true });
					}
				} else {
					notify(win, `Error: ${(response && response.data) || 'El cierre no se guardó'}`, 'error');
					if (typeof win.reconciliarEstadoCaja === 'function') win.reconciliarEstadoCaja();
				}
			})
			.catch((xhr) => {
				let msg = 'Error de conexión al cerrar. Verificando estado real…';
				if (xhr && xhr.responseJSON && xhr.responseJSON.data) {
					const d = xhr.responseJSON.data;
					if (typeof d === 'string' && d) msg = d;
				}
				notify(win, msg, 'warning');
				if (typeof win.reconciliarEstadoCaja === 'function') win.reconciliarEstadoCaja();
			});
	};

	win.mostrarResumenCierre = function mostrarResumenCierre(data) {
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: { action: 'pos_obtener_resumen_cierre', caja_id: data.caja_id, nonce: getNonce(win) },
			success(response) {
				if (response.success) win.mostrarResumenCompleto(data, response.data);
				else win.mostrarResumenBasico(data);
			},
			error() {
				win.mostrarResumenBasico(data);
			},
		});
	};

	win.mostrarResumenBasico = function mostrarResumenBasico(data) {
		const diferencia =
			parseFloat(data.monto_cierre || 0) -
			(parseFloat(data.monto_inicial || 0) + parseFloat(data.ventas_total || 0));
		const resumenHtml = `
			<div class="resumen-cierre">
				<div class="cierre-header">
					<h3>🔒 CAJA CERRADA EXITOSAMENTE</h3>
					<p class="fecha-cierre">${new Date().toLocaleString('es-ES')}</p>
				</div>
				<div class="cierre-totales">
					<div class="total-linea"><span>Monto inicial:</span><span>$${parseFloat(data.monto_inicial || 0).toFixed(2)} / Bs. ${parseFloat(data.monto_inicial_bs || 0).toFixed(2)}</span></div>
					<div class="total-linea"><span>Ventas del día:</span><span>$${parseFloat(data.ventas_total || 0).toFixed(2)}</span></div>
					<div class="total-linea destacado"><span>Total esperado:</span><span>$${(parseFloat(data.monto_inicial || 0) + parseFloat(data.ventas_total || 0)).toFixed(2)}</span></div>
					<div class="total-linea"><span>Monto declarado:</span><span>$${parseFloat(data.monto_cierre || 0).toFixed(2)}</span></div>
					<div class="total-linea diferencia ${diferencia >= 0 ? 'positiva' : 'negativa'}"><span>Diferencia:</span><span>$${diferencia.toFixed(2)}</span></div>
					<div class="total-linea"><span>Pedidos procesados:</span><span>${data.pedidos_count || 0}</span></div>
				</div>
				<div class="cierre-acciones">
					<button id="imprimir-cierre-btn" class="btn-accion btn-imprimir">🖨️ Imprimir Cierre</button>
					<button id="nueva-caja-btn" class="btn-accion btn-abrir">🔓 Abrir Nueva Caja ($0)</button>
				</div>
			</div>`;
		$('#lista-movimientos').html(resumenHtml);
		win.datosCierre = {
			...data,
			diferencia,
			total_esperado: parseFloat(data.monto_inicial || 0) + parseFloat(data.ventas_total || 0),
		};
	};

	win.mostrarResumenCompleto = function mostrarResumenCompleto(dataCierre, detalles) {
		const diferencia =
			parseFloat(dataCierre.monto_cierre || 0) -
			(parseFloat(dataCierre.monto_inicial || 0) + parseFloat(dataCierre.ventas_total || 0));
		const usuario = getUserDisplayName(win);
		const fmt = win.formatearNombreMetodo;
		const sym = win.obtenerSimboloMoneda;

		let resumenHtml = `
			<div class="resumen-cierre">
				<div class="cierre-header">
					<h3>🔒 CAJA CERRADA EXITOSAMENTE</h3>
					<p class="fecha-cierre">${new Date().toLocaleString('es-ES')}</p>
					<p class="caja-info">Caja ID: ${dataCierre.caja_id} | Usuario: ${usuario}</p>
				</div>
				<div class="cierre-totales">
					<div class="total-linea"><span>Monto inicial:</span><span>$${parseFloat(dataCierre.monto_inicial || 0).toFixed(2)} / Bs. ${parseFloat(dataCierre.monto_inicial_bs || 0).toFixed(2)}</span></div>
					<div class="total-linea"><span>Ventas del día (${detalles.pedidos || 0} pedidos):</span><span>$${parseFloat(dataCierre.ventas_total || 0).toFixed(2)}</span></div>
					<div class="total-linea destacado"><span>Total esperado:</span><span>$${(parseFloat(dataCierre.monto_inicial || 0) + parseFloat(dataCierre.ventas_total || 0)).toFixed(2)}</span></div>
					<div class="total-linea"><span>Monto declarado:</span><span>$${parseFloat(dataCierre.monto_cierre || 0).toFixed(2)}</span></div>
					<div class="total-linea diferencia ${diferencia >= 0 ? 'positiva' : 'negativa'}"><span>Diferencia:</span><span>$${diferencia.toFixed(2)}</span></div>
				</div>`;

		if (detalles.metodos_pago && Object.keys(detalles.metodos_pago).length > 0) {
			resumenHtml += `<div class="cierre-metodos"><h4>💳 Métodos de Pago</h4><div class="metodos-resumen">`;
			Object.entries(detalles.metodos_pago).forEach(([metodo, monto]) => {
				resumenHtml += `<div class="metodo-resumen"><span>${fmt(metodo)}:</span><span>${sym(metodo)}${parseFloat(monto).toFixed(2)}</span></div>`;
			});
			resumenHtml += `</div></div>`;
		}

		if (parseFloat(detalles.creditos_total || 0) > 0 || (detalles.creditos_pedidos && detalles.creditos_pedidos.length)) {
			const listaCred = detalles.creditos_pedidos || [];
			resumenHtml += `<div class="cierre-creditos" style="margin-top:10px;padding:8px;background:#ffebee;border-radius:6px;">
				<h4 style="margin:0 0 6px;">💳 Créditos</h4>
				<p style="margin:0 0 6px;"><strong>Total:</strong> $${parseFloat(detalles.creditos_total || 0).toFixed(2)}</p>`;
			if (listaCred.length) {
				resumenHtml += '<ul style="margin:0;padding-left:16px;font-size:12px;">';
				listaCred.forEach((c) => {
					const num = String(c.numero || c.order_id || '');
					const cli = String(c.cliente || '').trim();
					resumenHtml += `<li>#${num}${cli ? ` · ${cli}` : ''}: $${parseFloat(c.monto || 0).toFixed(2)}</li>`;
				});
				resumenHtml += '</ul>';
			}
			resumenHtml += '</div>';
		}

		const abonosUsdCierre = parseFloat(detalles.abonos_credito_total_usd || 0);
		const abonosBsCierre = parseFloat(detalles.abonos_credito_total_bs || 0);
		if (abonosUsdCierre > 0 || abonosBsCierre > 0) {
			resumenHtml += `<div class="cierre-abonos" style="margin-top:10px;padding:8px;background:#e8f5e9;border-radius:6px;">
				<h4 style="margin:0 0 6px;">💵 Abonos de crédito cobrados</h4>
				<p style="margin:0;"><strong>Total:</strong> $${abonosUsdCierre.toFixed(2)}`;
			if (abonosBsCierre > 0) {
				resumenHtml += ` · Bs. ${abonosBsCierre.toFixed(2)}`;
			}
			resumenHtml += `</p>
				<p style="margin:4px 0 0;font-size:12px;color:#555;">Incluidos en los métodos de pago del cierre.</p>
			</div>`;
		}

		if (detalles.productos_vendidos?.length) {
			resumenHtml += `<div class="cierre-productos"><h4>📦 Top Productos Vendidos</h4><div class="productos-resumen">`;
			detalles.productos_vendidos.slice(0, 3).forEach((producto) => {
				resumenHtml += `<div class="producto-resumen"><span>${producto.name} (${producto.quantity}):</span><span>$${parseFloat(producto.total).toFixed(2)}</span></div>`;
			});
			resumenHtml += `</div></div>`;
		}

		resumenHtml += `
				<div class="cierre-acciones">
					<button id="imprimir-cierre-btn" class="btn-accion btn-imprimir">🖨️ Imprimir Cierre</button>
					<button id="nueva-caja-btn" class="btn-accion btn-abrir">🔓 Abrir Nueva Caja ($0)</button>
				</div>
			</div>`;
		$('#lista-movimientos').html(resumenHtml);
		win.datosCierre = {
			...dataCierre,
			detalles,
			diferencia,
			total_esperado: parseFloat(dataCierre.monto_inicial || 0) + parseFloat(dataCierre.ventas_total || 0),
		};
	};

	win.testFuncionesCaja = function testFuncionesCaja() {
		return {
			cargarEstadoCaja: typeof win.cargarEstadoCaja === 'function',
			actualizarInterfaz: typeof win.actualizarInterfaz === 'function',
			mostrarEstadoPorDefecto: typeof win.mostrarEstadoPorDefecto === 'function',
			imprimirReporteCaja: typeof win.imprimirReporteCaja === 'function',
		};
	};
}

/** @deprecated use attachCajaGlobals */
export function initCajaModule(win, $) {
	if (!$) $ = win.jQuery;
	attachCajaGlobals(win, $);
}
